import React                                                  from 'react';
import { SemanticUIColor, SemanticUISize, Uuid }              from "@src/types";
import { Header, Icon, Label, Radio, Segment, SemanticICONS } from "semantic-ui-react";
import _                                                      from "underscore";
import { runIfFunction }                                      from "@src/util";
import classNames                                             from "classnames";
import { Cell, Grid }                                         from "styled-css-grid";
import { ItemWithIcon }                                       from "@src/views/components/display/ItemWithIcon";
import { FinePrintMessage }                                   from "@src/views/components/util/messaging/FinePrintMessage";


interface TemplateDisplayContainerProps {
    id: Uuid,
    name: string,
    selected?: boolean,
    selectable?: boolean,
    icon?: SemanticICONS,
    description?: string,
    tags?: string[],
    isArchived?: boolean,
    onClick?: ( templateId: Uuid ) => void,
    formName?: string,
}

const TemplateDisplayContainerDefaultProps = {
    id:          null,
    name:        null,
    icon:        null,
    description: null,
    tags:        [],
    isArchived:  false,
    selectable:  false,
    selected:    false,
    onClick:     null,
    formName:    'templateId',
} satisfies Partial<TemplateDisplayContainerProps>

function TemplateDisplayContainer( _props: TemplateDisplayContainerProps ){

    const props = { ...TemplateDisplayContainerDefaultProps, ..._props };

    const hasDescription = !_.isEmpty( props.description ),
          isArchived     = ( props.isArchived === true ),
          isSelectable   = ( props.selectable === true );

    const handleOnClick = ( e ) => {

        runIfFunction( props.onClick, props.id );
    }

    return (

        <Segment raised onClick={ handleOnClick } className={ classNames( {
            'cursor--pointer':         true,
            'outline--hover':          !props.selected,
            'outline-sm':              true,
            'outline--colored-purple': true,
        } ) }>

            <Grid columns={ `auto 1fr auto` } rows={ `auto auto` } areas={ _.compact( [
                `radio title title`,
                hasDescription ? `radio description label` : null
            ] ) }>

                <Cell area={ 'radio' }>
                    { isSelectable && <Radio name={ 'templateId' } checked={ props.selected } value={ props.id }/> }
                </Cell>

                <Cell area={ 'title' }>

                    { props.icon ? (
                        <ItemWithIcon rtl={ true } iconComponent={ <Icon name={ props.icon } size={ SemanticUISize.LARGE } color={ SemanticUIColor.PURPLE }/> }>
                            <Header as={ 'h4' }>{ props.name }</Header>
                        </ItemWithIcon>
                    ) : (
                          <Header as={ 'h4' }>{ props.name }</Header>
                      ) }
                </Cell>

                { hasDescription && (
                    <Cell area={ 'description' }>
                        <FinePrintMessage>{ props.description }</FinePrintMessage>
                    </Cell>
                ) }

                { isArchived && (
                    <Cell area={ 'label' }>
                        <Label size={ 'mini' } basic color={ 'grey' }>Archived</Label>
                    </Cell>
                ) }

            </Grid>

        </Segment>
    )
}

export {
    TemplateDisplayContainer,
    TemplateDisplayContainerDefaultProps,
    type TemplateDisplayContainerProps,
};
